/**
 * @generated SignedSource<<15f8864a6e0d9e55bb63384fefa0a151>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetPasswordStepQuery$variables = {
  clubSlug: string;
};
export type SetPasswordStepQuery$data = {
  readonly unauthenticatedClub: {
    readonly name: string;
  } | null | undefined;
};
export type SetPasswordStepQuery = {
  response: SetPasswordStepQuery$data;
  variables: SetPasswordStepQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clubSlug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "clubSlug"
      }
    ],
    "concreteType": "UnauthenticatedClub",
    "kind": "LinkedField",
    "name": "unauthenticatedClub",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetPasswordStepQuery",
    "selections": (v1/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetPasswordStepQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "27b9957856156c03e7400463592e65a9",
    "id": null,
    "metadata": {},
    "name": "SetPasswordStepQuery",
    "operationKind": "query",
    "text": "query SetPasswordStepQuery(\n  $clubSlug: String!\n) {\n  unauthenticatedClub(slug: $clubSlug) {\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a2cc3fa6053d594c272b5bd6749c23a";

export default node;
